import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerTimelineProvider } from '../../providers/consumer-timeline-handler';
import { BaseListPage } from '../../providers/base-list-page';
import { Globals } from '../../providers/globals';
import { ConsumerMessageDetailPage } from '../../pages/consumer-message-detail/consumer-message-detail';

import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerBusinessMainHandlerProvider } from '../../providers/consumer-business-main-handler';

declare var google: any;

/**
 * Generated class for the ConsumerBusinessTimelinePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-business-timeline',
  templateUrl: 'consumer-business-timeline.html',
})
export class ConsumerBusinessTimelinePage extends BaseListPage {
	business: any = {
		Id: 0,
		ImagePath: ""
	};

	businessId: any;
	filePath: any;
	businessFilePath: any;

	messages: any;
  	hasMessages: boolean = false;

	constructor(
		public consumerBusinessMainHandlerProvider: ConsumerBusinessMainHandlerProvider, 
		public globals: Globals,
		public consumerTimelineProvider: ConsumerTimelineProvider,
		public navCtrl: NavController, 
		public navParams: NavParams) {
		super();
			this.filePath = this.globals.fileUrl;
			this.business = this.consumerBusinessMainHandlerProvider.business;	
			this.businessFilePath = this.globals.fileUrl + this.business.ImagePath;

	    this.isLoading = true;
	  	this.load(null);	
	}

	ionViewDidEnter() {
	}  	

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerMessageTimelinePage');
	}

	doRefresh(refresher) {
		this.params.page = 1;

		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;			
		  	refresher.complete();
		});
	}    

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
		  infiniteScroll.complete();
		  return;
		} 

		this.params.page++;
		this.isFetchingMore = true;
		
		this.load(()=>{
		  infiniteScroll.complete();
		});
	}

	load(cb){
		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.params.cbAfter = cb;

		console.log("Businessid: " + this.business.Id);

		this.consumerTimelineProvider.getBusinessTimeline(this.business.Id, this.params);
	}	

	viewMessageDetail(message) {
		this.navCtrl.push(ConsumerMessageDetailPage, {
		  message: message
		})
	}	
}



// WEBPACK FOOTER //
// ./src/pages/consumer-business-timeline/consumer-business-timeline.ts